import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./HeroBK.scss";

// Artwork (stack)
import HeroStack from "../../../../resources/images/brandkeeper/hero-stack.png";

const HeroBK = () => {
  const location = useLocation();

  // If we're already on /brandkeeper/pricing, intercept the click and just scroll.
  const handleViewPlansClick = (e) => {
    if (location.pathname === "/brandkeeper/pricing") {
      e.preventDefault();
      const el = document.getElementById("bk-plans-wrap");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  return (
    <section className="brandkeeper-hero" aria-label="BrandKeeper hero">
      <div className="bk__inner">
        {/* MOBILE GROUP WRAPPER */}
        <div className="bk__group">
          {/* LEFT: copy */}
          <div className="bk__copy">
            <p className="bk__eyebrow">
              <strong className="bk__eyebrow-strong">
                Monthly Brand-Ready Design Subscription
              </strong>{" "}
              · Built for Service Businesses
            </p>

            <h1 className="bk__title">
              World-class work
              <br />
              deserves a brand
              <br />
              that proves it.
            </h1>

            <p className="bk__lead">
              <strong>BrandKeeper™</strong> is a monthly brand-ready design
              subscription for service business owners ready to look as premium
              as they perform. Get conversion-focused static ad designs, short
              video ads, and strategic brand consulting to help you close
              premium clients.
            </p>
          </div>

          {/* CTAs */}
          <div className="bk__cta">
            <a
              href="https://tally.so/r/0Q5Mj6"
              className="btn btn-primary"
              aria-label="Apply for BrandKeeper™"
              target="_blank"
              rel="noopener noreferrer"
            >
              Apply for BrandKeeper™
            </a>

            {/* View plans → clean URL; scroll handled on route + onClick (same route) */}
            <Link
              to="/brandkeeper/pricing"
              className="btn btn-secondary-white"
              aria-label="See what's included"
              onClick={handleViewPlansClick}
            >
              See what&apos;s included
            </Link>
          </div>

          {/* SUB-CTA / TRUST TEXT WITH CERTIFIED ICON */}
          <p className="bk__sub-cta">
            <svg
              className="bk__trust-icon"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              <path d="m9 12 2 2 4-4" />
            </svg>
            <span>
              Trusted by service business owners across the US, UK, and AU. Flat
              monthly rate · No lock-in contracts.
            </span>
          </p>
        </div>

        {/* RIGHT: artwork (hidden on mobile via CSS) */}
        <div className="bk__art">
          <img
            className="bk__stack"
            src={HeroStack}
            alt="BrandKeeper design deliverables stack preview"
            loading="eager"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroBK;